import { CHANNEL_ID, HOOK_ID } from '@@types/common';
import { CreateHookResponse, HookRequestParams, HooksResponse, HookUpdateRequestParams } from '@@types/Hook';

import { ALL_API_SIZE, URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';
import { head, prop } from 'ramda';

class HookApi {
  constructor(private api: Api2) {}

  createHook = (params: HookRequestParams) => {
    return (this.api.resultRequester.post(`${URLS.WAS_API}/bots`, [params]) as Promise<CreateHookResponse[]>).then(
      head
    );
  };

  fetchHooks = (channelId: CHANNEL_ID): Promise<HooksResponse> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/bots?size=${ALL_API_SIZE}`, {
      params: { channelId },
    });
  };

  fetchAllHookCount = (): Promise<number> => {
    return (
      this.api.resultRequester.get(`${URLS.WAS_API}/bots`, {
        params: { size: 1 },
      }) as Promise<{
        totalCount: number;
      }>
    ).then(prop('totalCount'));
  };

  updateHook = (params: HookUpdateRequestParams) => {
    const { id, name } = params;
    return this.api.contentsRequester.put(`${URLS.WAS_API}/bots/${id}`, { name });
  };

  deleteHook = (channelId: CHANNEL_ID, hookId: HOOK_ID): Promise<null> => {
    return this.api.contentsRequester.post(`${URLS.WAS_API}/bots/${hookId}/detach-channel`, { channelId });
  };
}

export default HookApi;
